import React from 'react'

const ImageTrackingPixel = ({ url }) => {
  if (!url) {
    return null
  }
  return <img src={url} className='bs-image-hidden' alt='' />
}

export default ImageTrackingPixel
